import Typography from 'material-ui/Typography'
import * as React from 'react'
import { StyleRulesCallback, withStyles } from 'material-ui/styles'
import { ComponentType, SFC } from 'react'
import { WithStyles } from 'material-ui'

const styles: StyleRulesCallback = theme => ({
    root: {
        [theme.breakpoints.up('sm')]: {
            padding: '100px 0',
            minHeight: 180,
            margin: '0 auto 15px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '60px 0',
            minHeight: 60,
            margin: '0 auto',
        },
    },
    h1: {
        [theme.breakpoints.up('sm')]: {
            fontSize: 72
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: 40
        },
    },
    h3: {
        [theme.breakpoints.up('sm')]: {
            fontSize: 48
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: 24
        },
    },

})

const Component: SFC<WithStyles> = ({classes}) => {
    return (
        <div
            className={classes.root}
            style={{
                position: 'relative',

                maxWidth: 1300,

                background: 'url("/img/dotnet.svg") no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'center center'
            }}
        >
            <div>

                <Typography type='display4' className={classes.h1}>
                    Where Ideas Get Built.
                </Typography>
                <Typography type='display3' className={classes.h3}>
                    We enable digital success
                </Typography>
            </div>
        </div>
    )
}
export const DotNetSpread: ComponentType = withStyles(styles)(Component)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/index/DotNetSpread.tsx